"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ThemeContext = /*#__PURE__*/_react["default"].createContext({
  componentsStyle: null,
  additionalStyles: null,
  rootContainer: null,
  scrollContainer: null,
  useStyle: null,
  target: 'web'
});
var _default = exports["default"] = ThemeContext;